module.exports = __webpack_public_path__ + "static/media/r13.13c0fea7.png";